import { Injectable, OnDestroy } from '@angular/core';
import { getDetails } from '../../../modules/auth/state/auth.state';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface UserRole {
  role_id: number;
  role_name: string;
  privilege: number | number[];
}

@Injectable({
  providedIn: 'root'
})
export class RoleAuthorizationService implements OnDestroy {
  private userRole: UserRole | null = null;
  private destroy$ = new Subject<void>();

  constructor(private store: Store) {
    this.store.select(getDetails).pipe(takeUntil(this.destroy$)).subscribe(userDetails => {
      this.userRole = userDetails?.userRoles;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getPrivilege(): number | number[] | null {
    return this.userRole ? this.userRole.privilege : null;
  }

   getRoleName(): string | null {
    return this.userRole ? this.userRole.role_name : null;
  }

  hasAccess(allowedPrivileges: number[] | undefined): boolean {
    if (!allowedPrivileges) return false;
    if (!this.userRole) return false;
    const { privilege } = this.userRole;
    if (Array.isArray(privilege)) {
      return privilege.some((p) => allowedPrivileges.includes(p));
    }
    return allowedPrivileges.includes(privilege);
  }

  isSuperAdmin(): boolean {
    return this.userRole?.role_name === 'SuperAdmin' && this.hasAccess([1]);
  }
  
  isAdmin(): boolean {
    return this.userRole?.role_name === 'Admin' && this.hasAccess([2]); 
  }
  
  isViewer(): boolean {
    return this.hasAccess([3]); 
  }

  hasRole(roleName: string): boolean {
    return this.userRole?.role_name === roleName;
  }
  
  canPerformAction(requiredPrivilege: number): boolean {
    return this.hasAccess([requiredPrivilege]); // Wrap privilege in an array
  }
  
}
